import { Skeleton } from 'antd';
import styles from './Day.module.css';

export const MonthSkeleton = () => {
  return (
    <div>
      {[1, 2, 3, 4].map((weekNumber) => {
        return (
          <div key={'week-skeleton-' + weekNumber}>
            <div className={styles.weekWrapper}>
              <p className={styles.weekdayMobile}>Week {weekNumber}:</p>
              <div className={styles.dayWrapper}>
                <p className={styles.weekday}>Week {weekNumber}:</p>
                <p className={styles.start}>Start</p>
                <p className={styles.stop}>End</p>
                <p className={styles.lunch}>Lunch</p>
                <p className={styles.ordHours}>Ord. hours</p>
                <p className={styles.overtimeHours}>Overtime</p>
                <p className={styles.flexTime}>Flex</p>
                <p className={styles.total}>Total</p>
                <p className={styles.brutto}>Brutto</p>
              </div>
              {[1, 2, 3, 4, 5, 6, 7].map((date) => (
                <DaySkeleton key={'day-skeleton-' + date} />
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export const DaySkeleton = () => {
  return (
    <div
      className={styles.dayWrapper}
      style={{
        color: 'black',
        background: 'white',
      }}
    >
      <div className={styles.date} style={{ overflow: 'hidden', maxWidth: '100%' }}>
        <Skeleton.Input active size="default" style={{ width: '20px', maxWidth: '100%' }} />
      </div>
      <div className={styles.weekday} style={{ overflow: 'hidden', maxWidth: '100%' }}>
        <Skeleton.Input active size="default" style={{ width: '40px', maxWidth: '100%' }} />
      </div>
      <div className={styles.workday} style={{ overflow: 'hidden', maxWidth: '100%' }}>
        <Skeleton.Input active size="default" style={{ width: '16px', height: '16px', maxWidth: '100%' }} />
      </div>
      <div className={styles.start} style={{ overflow: 'hidden', maxWidth: '100%' }}>
        <Skeleton.Input active size="default" style={{ width: '60px', maxWidth: '100%' }} />
      </div>
      <div className={styles.stop} style={{ overflow: 'hidden', maxWidth: '100%' }}>
        <Skeleton.Input active size="default" style={{ width: '60px', maxWidth: '100%' }} />
      </div>
      <div className={styles.lunch} style={{ overflow: 'hidden', maxWidth: '100%' }}>
        <Skeleton.Input active size="default" style={{ width: '80px', maxWidth: '100%' }} />
      </div>
      <div className={styles.ordHours} style={{ overflow: 'hidden', maxWidth: '100%' }}>
        <Skeleton.Input active size="default" style={{ width: '40px', maxWidth: '100%' }} />
      </div>
      <div className={styles.overtimeHours} style={{ overflow: 'hidden', maxWidth: '100%' }}>
        <Skeleton.Input active size="default" style={{ width: '50px', maxWidth: '100%' }} />
      </div>
      <div className={styles.flexTime} style={{ overflow: 'hidden', maxWidth: '100%' }}>
        <Skeleton.Input active size="default" style={{ width: '16px', maxWidth: '100%' }} />
      </div>
      <div className={styles.total} style={{ overflow: 'hidden', maxWidth: '100%' }}>
        <Skeleton.Input active size="default" style={{ width: '40px', maxWidth: '100%' }} />
      </div>
      <div className={styles.brutto} style={{ overflow: 'hidden', maxWidth: '100%' }}>
        <Skeleton.Input active size="default" style={{ width: '60px', maxWidth: '100%' }} />
      </div>
    </div>
  );
};
